import {Component, OnDestroy, OnInit} from '@angular/core';
import {ApplicationService} from '../application.service';
import {animate, style, transition, trigger} from '@angular/animations';
import {PersistenceService} from '../../../../../persistence/src/lib/persistence.service';
import {Patient} from '../../../../../persistence/src/models/patient.model';
import {DataExchangeService} from '../../../../../surface3d/src/lib/API/Public/data-exchange.service';


@Component({
    selector: 'burncase-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.css'],
    animations: [
        trigger('fadeIn', [
            transition(':enter', [
                style({opacity: 0}),
                animate('5s linear', style({opacity: 1}))
            ])
        ])
    ]
})
export class LoadingComponent implements OnInit, OnDestroy {

    constructor(private applicationService: ApplicationService,
                private dataExchangeService: DataExchangeService,
                private persistenceService: PersistenceService) {
        if (dataExchangeService.patient.id) {
            const patient = new Patient('1234');
            patient.birthdate = new Date('1994-07-18');
            patient.gender = 'female';
            this.dataExchangeService.patient.information = patient;
            this.dataExchangeService.patient.changeBMI(30);
            // this.persistenceService.get(this.dataExchangeService.patientId).subscribe((patient: Patient) => {
            //
            //     if (patient.gender) {
            //         console.warn(patient.gender);
            //         this.dataExchangeService.patient = patient;
            //         // TODO set BMI
            //         // this.dataExchangeService.changeBMI(30);
            //     }
            //
            // });

            // this.persistenceService.loadMeasurement(this.dataExchangeService.patientId).subscribe((measurement: Measurement) => {
            //     console.log(measurement);
            // });
        }

    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.applicationService.appStarted = true;
    }

}
